import React from 'react';

const Play = () => {
    return (
      <React.Fragment>
        <div className="btn__base r5c2">
          <div className="btn"></div>
        </div>
      </React.Fragment>
    );
  };

export default Play;